export const formatFbclid = (clickId: string) => {
  return 'fb.1.' + new Date().getTime() + '.' + clickId;
};
